import classNames from 'classnames';
import Linkify from 'react-linkify';

import useActiveAnnouncement from 'src/Hooks/Queries/useActiveAnnouncement';
import { AnnouncementLevel } from 'src/types/announcement.types';

import styles from './AnnouncementBanner.module.scss';

const levelClass: Record<AnnouncementLevel, string> = {
  [AnnouncementLevel.Info]: styles.info,
  [AnnouncementLevel.Warning]: styles.warning,
  [AnnouncementLevel.Critical]: styles.critical,
};

const linkifyDecorator = (href: string, text: string, key: number) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer" className={styles.link}>
    {text}
  </a>
);

const AnnouncementBanner = () => {
  const { data: announcement } = useActiveAnnouncement();

  if (!announcement) return null;

  return (
    <div className={classNames(styles.container, levelClass[announcement.level])} role="status">
      <span className={styles.message}>
        <Linkify componentDecorator={linkifyDecorator}>{announcement.message}</Linkify>
      </span>
    </div>
  );
};

export default AnnouncementBanner;
